import { InjectionToken } from '@angular/core';

export const EL_SELECT_INJECTION_TOKEN = new InjectionToken('EL_SELECT_INJECTION_TOKEN');
